"use client";

import { ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import {
  FadeInUp,
  StaggerContainer,
  StaggerItem,
} from "@/components/ui/motion";

const capabilities = [
  {
    metric: "1M+",
    label: "events/month capacity",
    description: "Built to scale with your growth",
  },
  {
    metric: "99.9%",
    label: "uptime SLA target",
    description: "Enterprise-grade reliability",
  },
  {
    metric: "<50ms",
    label: "execution latency",
    description: "Real-time workflow processing",
  },
];

export function SocialProof() {
  const navigate = useRouter();

  return (
    <section className="py-16 lg:py-20 border-y border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <FadeInUp>
          <p className="text-center text-sm font-medium text-muted-foreground mb-12">
            Platform capabilities
          </p>
        </FadeInUp>

        <StaggerContainer className="grid md:grid-cols-3 gap-8 lg:gap-12 max-w-4xl mx-auto mb-12">
          {capabilities.map((item, index) => (
            <StaggerItem key={index} className="text-center">
              <div className="text-4xl lg:text-5xl font-bold gradient-text mb-2">
                {item.metric}
              </div>
              <div className="text-sm font-medium text-foreground mb-1">
                {item.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {item.description}
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>

        <FadeInUp delay={0.3} className="text-center">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate.push("/register")}
            className="group"
          >
            Join the waitlist
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </FadeInUp>
      </div>
    </section>
  );
}
